<div class="main-content">
  <div>
    <div class="page-header-image">
      <img src="assets/branded/img/oh-no-bg.png" alt="" />
    </div>
    <div class="content">
      <div class="title">{{ 'onboarding.skip.title' | transloco }}</div>
      <div class="description" [innerHTML]="contentKey | transloco"></div>
    </div>
  </div>

  <div class="buttons">
    <c-button (action)="continue()">{{ 'onboarding.skip.continue' | transloco }}</c-button>
    <c-button (action)="close()" type="secondary">{{ 'common.go-back' | transloco }}</c-button>
  </div>
</div>
 